import React from 'react';
import { HourglassIcon, UsersIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { launchAfterPrice, price } from '../data/copy';
import { launchSpotsRemaining, launchSpotsTotal, spotsTakenPercent } from '../utils/offer';
export function UrgencySection() {
  return <section className="defer-paint w-full bg-canvas pb-14 sm:pb-20" aria-labelledby="urgency-heading" data-id="element-262" data-mp="31ipiyxwioh3d">
      <div className="mx-auto max-w-2xl px-6" data-id="element-263" data-mp="3g7carz3bz1bh">
        <div className="rounded-2xl bg-navy p-6 shadow-xl shadow-navy/20 sm:p-8" data-id="element-264" data-mp="3ga88pnf6hpzx">
          <h2 id="urgency-heading" className="flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-wider text-gold" data-id="element-265" data-mp="3b8is7s96sk4g">
            <HourglassIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-266" data-mp="3l6ovad6qbwaw" />
            The {price} launch price ends soon
          </h2>
          <div className="mt-5" data-id="element-267" data-mp="1uvar00z8j8bp">
            <CountdownTimer data-id="element-268" data-mp="1qt75ejiuqncp" />
          </div>
          <p className="mt-4 text-center text-xs font-bold uppercase tracking-wider text-white" data-id="element-269" data-mp="1qu8ptelrcm73">
            After launch, the complete system will be {launchAfterPrice}.
          </p>

          <div className="mt-7" data-id="element-270" data-mp="2xrzlqattdpzu">
            <div className="flex items-center justify-between gap-4 text-xs font-bold uppercase tracking-wider" data-id="element-271" data-mp="2xt0vmbz3g6fz">
              <span className="flex items-center gap-1.5 text-white" data-id="element-272" data-mp="32prawx32qy0c">
                <UsersIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-273" data-mp="37jc8io0r9pz0" />
                Launch spots remaining
              </span>
              <span className="text-gold" data-id="element-274" data-mp="3gj8wsoj8gmtj">
                {launchSpotsRemaining} of {launchSpotsTotal} left
              </span>
            </div>
            <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-navy-deep" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots taken" data-id="element-275" data-mp="3ljn2w119xmox">
              <div className="h-full rounded-full bg-gold" style={{
              width: `${spotsTakenPercent}%`
            }} data-id="element-276" data-mp="1r5voko802en5" />
            </div>
            <p className="mt-1.5 text-right text-xs text-muted" data-id="element-277" data-mp="1o2fyi7m0mmlf">
              {spotsTakenPercent}% of spots taken
            </p>
          </div>
        </div>
      </div>
    </section>;
}